import {Log} from '@aboutyou/mlm';

/**
 * SHA-256 the auth token so it can be persisted as an ownership marker without duplicating a
 * usable credential outside the auth cookie. Returns null when hashing is unavailable (e.g. a
 * non-secure context without `crypto.subtle`); callers must then treat the ownership check as
 * failed instead of falling back to the raw token.
 */
export const sha256Fingerprint = async (
  token: string,
): Promise<string | null> => {
  try {
    const subtle = globalThis.crypto?.subtle;
    if (!subtle) {
      return null;
    }

    const digest = await subtle.digest(
      'SHA-256',
      new TextEncoder().encode(token),
    );

    return Array.from(new Uint8Array(digest))
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  } catch (error) {
    Log.error('@aboutyou/user', 'Failed hashing user token', {error});
    return null;
  }
};
